export const ChatBarTemplate = `
<div class="chat__user-info">
  <span class="chat__user-title">{{title}}</span>
  <span class="chat__user-members"></span>
</div>
{{{addUserButton}}}
`;
